import {
  ContactSupport,
  People,
  ShoppingCart,
  WorkOutline,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

import Head from "../../components/Head/Head";
import NavBar from "../../components/NavBar/NavBar";
import Offices from "../../components/Offices/Offices";
import Maps from "../../components/Maps/Maps";
import Prefer from "../../components/Prefer/Prefer";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import ContactUs from "../../components/ContactUs/ContactUs";
import Footer from "../../components/Footer/Footer";

import CompanyImg from "../../images/company.png";
import Translator1 from "../../images/translators/t2.png";
import Translator2 from "../../images/translators/t3.png";
import Translator3 from "../../images/translators/t4.png";
import Translator4 from "../../images/translators/t6.png";
import Translator5 from "../../images/translators/t7.png";
import Translator9 from "../../images/translators/t9.jpg";
import Translator10 from "../../images/translators/t10.jpg";
import Translator11 from "../../images/translators/t11.jpg";
import Clients from "../../images/clients-2-tone.png";

import "./Company.css";

const Company = () => {
  const location = useLocation();
  const [slide, setSlide] = useState(1);

  const handleSlide = (num) => {
    setSlide(num);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (slide >= 3) return setSlide(1);
      if (slide < 3) return setSlide((slide) => slide + 1);
    }, 10000);

    return () => clearInterval(interval);
  }, [slide]);

  useEffect(() => {
    if (location.hash.slice(1).trim() !== "") {
      const element = document.getElementById(location.hash.slice(1).trim());

      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const fadeinStyle = {
    opacity: 1,
  };

  return (
    <div className="company">
      <Head
        title={"Certified Translation services-Interpretation | localization"}
        description={
          "Oneconverse is a trusted translation & interpretation agency. Go global with our certified translation, interpretation services, and translators near you."
        }
        keywords={
          "translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations"
        }
      />
      <NavBar white company />
      <div className="company__hero position-relative"></div>
      <div className="company__quality container d-flex align-end justify-between position-relative z-3">
        <div className="d-flex flex-column align-center justify-start p-40">
          <ShoppingCart style={{ fontSize: "50px" }} className="icon-blue" />
          <span className="font-bolder font-big py-20">
            Fast & Quick Delivery
          </span>
          <p>
            Delivery is one of the most important elements of translation. Our
            translators are all professional, courteous, and on time.
          </p>
        </div>
        <div className="d-flex flex-column align-center justify-start p-40">
          <People style={{ fontSize: "50px" }} />
          <span className="font-bolder font-big py-20">
            Professional Translators
          </span>
          <p>
            Our professional translators are dedicated to translating your
            content into the target language. They deliver high-quality
            translations that you can rely on for your need.
          </p>
        </div>
        <div className="d-flex flex-column align-center justify-start p-40">
          <ContactSupport style={{ fontSize: "50px" }} className="icon-blue" />
          <span className="font-bolder font-big py-20">
            24/7 Customer Support
          </span>
          <p>
            We offer a high-quality customer care support for all our clients.
            Our customer care team provides efficient support for all types of
            inquiries that you might have about our translation service.
          </p>
        </div>
      </div>
      <div
        id="about-us"
        className="company__about container d-flex align-end justify-between mb-40"
      >
        <img
          className="position-relative company__image"
          src={CompanyImg}
          alt=""
        />
        <div className="position-relative p-40">
          <span className="font-heavy">About Us</span>
          <h3 className="font-subhead py-10">
            Ever heard of a translation company so realiable?
          </h3>
          <p className="text-justify">
            Oneconverse team of experts translators provide you with fast,
            accurate, and affordable translations at your fingertips. Our
            translators have years of experience in their respective fields and
            are able to translate into more than 100 languages.
          </p>
        </div>
      </div>
      <div id="process" className="company__process container grid c-3 gap-40">
        <div className="p-40">
          <span className="font-heavy">Our Process</span>
          <h2 className="py-10">How we go about our translation process</h2>
          <p>
            As soon as payment is made the translation process commence. The
            process span through translation of document to target language to
            vetting of document before submission to client.
          </p>
        </div>
        <div className="p-40 d-flex flex-column align-center box-shadow-lg">
          <div className="d-flex align-center justify-center company__process__icon rounded-50">
            <WorkOutline fontSize="large" />
          </div>
          <span className="font-bold font-big p-10">Uploading</span>
          <p>
            Document to be translated is uploaded, scrutinized, evaluated,
            properly and securely saved for usage in further process.
          </p>
        </div>
        <div className="p-40 d-flex flex-column align-center box-shadow-lg">
          <div className="d-flex align-center justify-center company__process__icon rounded-50">
            <WorkOutline fontSize="large" />
          </div>
          <span className="font-bold font-big p-10">Allocation</span>
          <p>
            Most qualified, highly rated and project specific translator is
            sorted and allocated the project, Our translators are timely and do
            not cause any delay.
          </p>
        </div>
        <div className="p-40 d-flex flex-column align-center box-shadow-lg">
          <div className="d-flex align-center justify-center company__process__icon rounded-50">
            <WorkOutline fontSize="large" />
          </div>
          <span className="font-bold font-big p-10">Translation</span>
          <p>
            The actual translation is done here with careful attention to the
            specifics of the project, carrying along the tone, emotions, etc
            along to ensure most accurate translation.
          </p>
        </div>
        <div className="p-40 d-flex flex-column align-center box-shadow-lg">
          <div className="d-flex align-center justify-center company__process__icon rounded-50">
            <WorkOutline fontSize="large" />
          </div>
          <span className="font-bold font-big p-10">Vetting</span>
          <p>
            The project translated is subjected to rigid scrutiny and careful
            vetting to ensure the quality and standard of OneConverse is
            maintained, paying close attention to details.
          </p>
        </div>
        <div className="p-40 d-flex flex-column align-center box-shadow-lg">
          <div className="d-flex align-center justify-center company__process__icon rounded-50">
            <WorkOutline fontSize="large" />
          </div>
          <span className="font-bold font-big p-10">Approval</span>
          <p>
            Once all the boxes are checked, and the best solution is created,
            the project is approved and made easily available to our esteem
            clients.
          </p>
        </div>
      </div>
      <div
        style={{ height: "650px" }}
        id="feedback"
        className="position-relative d-flex align-end"
      >
        <div
          style={slide === 1 ? fadeinStyle : {}}
          className="company__customer container d-flex align-end justify-between position-absolute t-0 w-100"
        >
          <div style={slide === 1 ? fadeinStyle : {}} className="p-40">
            <span style={slide === 1 ? fadeinStyle : {}} className="font-heavy">
              Customers' Review
            </span>
            <h3 style={slide === 1 ? fadeinStyle : {}} className="py-10">
              The satisfaction our customers get from us
            </h3>
            <p style={slide === 1 ? fadeinStyle : {}} className="text-justify">
              Thanks to OneConverse my document translation is no longer a
              problem, I have need to translate documents periodically and
              having a company that dependeable to make the process easier is
              just AWESOME!!!.
            </p>
            <h3
              style={slide === 1 ? fadeinStyle : {}}
              className="font-sm text-right py-10"
            >
              ~ Bekim Disha
            </h3>
          </div>
          <img
            style={slide === 1 ? fadeinStyle : {}}
            className="position-relative company__image"
            src={Translator9}
            alt=""
          />
        </div>
        <div
          style={slide === 2 ? fadeinStyle : {}}
          className="company__customer container d-flex align-end justify-between position-absolute t-0 w-100"
        >
          <div style={slide === 2 ? fadeinStyle : {}} className="p-40">
            <span style={slide === 2 ? fadeinStyle : {}} className="font-heavy">
              Customers' Review
            </span>
            <h3 style={slide === 2 ? fadeinStyle : {}} className="py-10">
              The satisfaction our customers get from us
            </h3>
            <p style={slide === 2 ? fadeinStyle : {}} className="text-justify">
              After endless search for accurate translation agency, I came
              across OneConverse, but as at when I found them I needed more than
              the accuracy, I needed a fast delivery, and they came through.
            </p>
            <h3
              style={slide === 2 ? fadeinStyle : {}}
              className="font-sm text-right py-10"
            >
              ~ Mila Jacobs
            </h3>
          </div>
          <img
            style={slide === 2 ? fadeinStyle : {}}
            className="position-relative company__image"
            src={Translator10}
            alt=""
          />
        </div>
        <div
          style={slide === 3 ? fadeinStyle : {}}
          className="company__customer container d-flex align-end justify-between position-absolute t-0 w-100"
        >
          <div style={slide === 3 ? fadeinStyle : {}} className="p-40">
            <span style={slide === 3 ? fadeinStyle : {}} className="font-heavy">
              Customers' Review
            </span>
            <h3 style={slide === 3 ? fadeinStyle : {}} className="py-10">
              The satisfaction our customers get from us
            </h3>
            <p style={slide === 3 ? fadeinStyle : {}} className="text-justify">
              I never thought I can be a the convience of my house and order for
              translation without having to go through so many offices, the ease
              of translation OneConverse brings is unprecedented, they are
              simply the best.
            </p>
            <h3
              style={slide === 3 ? fadeinStyle : {}}
              className="font-sm text-right py-10"
            >
              ~ Mary Jonker
            </h3>
          </div>
          <img
            style={slide === 3 ? fadeinStyle : {}}
            className="position-relative company__image"
            src={Translator11}
            alt=""
          />
        </div>
        <div className="company__carousel__dot d-flex justify-center align-center p-20 position-absolute w-100">
          <div
            style={{ backgroundColor: slide === 1 ? "#076acc" : "" }}
            className="rounded-50 mr-20 pointer"
            onClick={() => handleSlide(1)}
          ></div>
          <div
            style={{ backgroundColor: slide === 2 ? "#076acc" : "" }}
            className="rounded-50 mr-20 pointer"
            onClick={() => handleSlide(2)}
          ></div>
          <div
            style={{ backgroundColor: slide === 3 ? "#076acc" : "" }}
            className="rounded-50 pointer"
            onClick={() => handleSlide(3)}
          ></div>
        </div>
      </div>
      <div
        id="translators"
        className="company__translator container grid c-3 gap-40"
      >
        <div className="p-40">
          <span className="font-heavy">Our Translators</span>
          <h2 className="py-10">
            Meet with our translators all over the world
          </h2>
          <p>
            Our world-class members are capable of providing highest quality of
            translation incomparable anywhere in world. They are masters in
            their fields with critical and total attention to details.
          </p>
        </div>
        <img className="w-100 h-100 company__image" src={Translator1} alt="" />
        <img className="w-100 h-100 company__image" src={Translator2} alt="" />
        <img className="w-100 h-100 company__image" src={Translator3} alt="" />
        <img className="w-100 h-100 company__image" src={Translator4} alt="" />
        <img className="w-100 h-100 company__image" src={Translator5} alt="" />
      </div>
      <div id="client" className="container">
        <img className="my-40 w-100 company__image" src={Clients} alt="" />
      </div>
      <div id="prefer">
        <Prefer />
      </div>
      <div id="offices">
        <Offices />
      </div>
      <div className="company__map">
        <Maps />
      </div>
      <ContactUs />
      <div className="container">
        <InstantQuote />
      </div>
      <Footer />
    </div>
  );
};

export default Company;
